// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/fault_override_on_policy_change/fault_override_on_policy_change.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
var pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb = require('../../../../../pbtypes/vehicle/skills/actions/set_fault_override/set_fault_override_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb);
goog.exportSymbol('proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.displayName = 'proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.toObject(includeInstance, f),
faultOverrideArgs: (f = msg.getFaultOverrideArgs()) && pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb.SetFaultOverrideActionArgs.toObject(includeInstance, f),
fromPolicy: jspb.Message.getFieldWithDefault(msg, 3, 0),
toPolicy: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs;
  return proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb.SetFaultOverrideActionArgs;
      reader.readMessage(value,pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb.SetFaultOverrideActionArgs.deserializeBinaryFromReader);
      msg.setFaultOverrideArgs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFromPolicy(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setToPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback.serializeBinaryToWriter
    );
  }
  f = message.getFaultOverrideArgs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb.SetFaultOverrideActionArgs.serializeBinaryToWriter
    );
  }
  f = message.getFromPolicy();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getToPolicy();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional TriggerArgs.ChannelCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.ChannelCallback}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.ChannelCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.ChannelCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.ChannelCallback|undefined} value
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
*/
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional skills.SetFaultOverrideActionArgs fault_override_args = 2;
 * @return {?proto.skills.SetFaultOverrideActionArgs}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.getFaultOverrideArgs = function() {
  return /** @type{?proto.skills.SetFaultOverrideActionArgs} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_actions_set_fault_override_set_fault_override_pb.SetFaultOverrideActionArgs, 2));
};


/**
 * @param {?proto.skills.SetFaultOverrideActionArgs|undefined} value
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
*/
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.setFaultOverrideArgs = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.clearFaultOverrideArgs = function() {
  return this.setFaultOverrideArgs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.hasFaultOverrideArgs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 from_policy = 3;
 * @return {number}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.getFromPolicy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.setFromPolicy = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 to_policy = 4;
 * @return {number}
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.getToPolicy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs} returns this
 */
proto.complimentary_actions.FaultOverrideOnPolicyChangeActionArgs.prototype.setToPolicy = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.complimentary_actions);
